/* global importName */
import store from '@/services/store'
import { getDeepProperty } from '@/helpers/deepObject.js'

const AudienceLayout = () => importName('@/scenes/Audience/components/AudienceLayout.vue', 'audience-layout')
const Engagement = () => importName('@/scenes/Audience/scenes/Engagement/Engagement.vue', 'engagement')
const Listeners = () => importName('@/scenes/Audience/scenes/Listeners/Listeners.vue', 'unique-listeners')
const Location = () => importName('@/scenes/Audience/scenes/Location/Location.vue', 'location')
const Technology = () => importName('@/scenes/Audience/scenes/Technology', 'technology')
const WebPlayers = () => importName('@/scenes/Audience/scenes/WebPlayers/WebPlayers.vue', 'webplayers')
const ShowDownloads = () => importName('@/scenes/Audience/scenes/ShowDownloads', 'show-downloads')
const ShowListeners = () => importName('@/scenes/Audience/scenes/ShowListeners', 'show-listeners')
const ShowLocation = () => importName('@/scenes/Audience/scenes/ShowLocation/Location.vue', 'show-location')
const Campaigns = () => importName('@/scenes/Audience/scenes/Campaigns/Campaigns.vue', 'campaigns')
const Overview = () => importName('@/scenes/Audience/scenes/Overview/Overview.vue', 'audience-overview')
const DMA = () => importName('@/scenes/Audience/scenes/DMA', 'dma')
const Overlap = () => importName('@/scenes/Audience/scenes/Overlap', 'overlap')

const audienceRoutes = [
  {
    path: 'audience',
    component: AudienceLayout,
    children: [
      {
        path: 'downloads',
        name: 'downloads',
        component: Engagement,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Downloads' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: '/',
        name: 'audience',
        component: Overview,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Overview' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: 'location/:region?',
        name: 'location',
        component: Location,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Location' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: 'dma',
        name: 'dma',
        component: DMA,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'DMA' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: 'webplayers',
        name: 'webplayers',
        component: WebPlayers,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Web Players' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: 'technology',
        name: 'technology',
        component: Technology,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Technology' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: 'unique-listeners',
        name: 'unique-listeners',
        component: Listeners,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Unique Listeners' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: 'compare/downloads',
        name: 'compare-shows',
        component: ShowDownloads,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'Downloads' }
          ],
          showPodcastMenu: true,
          compareAccountAnalytics: true
        },
        beforeEnter: async (to, from, next) => {
          const currentAccount = store.getters.currentAccount
          if (!getDeepProperty(currentAccount, 'features.has_network_analytics')) {
            next({
              name: 'audience',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      {
        path: 'compare/listeners',
        name: 'compare-listeners',
        component: ShowListeners,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'Unique Listeners' }
          ],
          showPodcastMenu: true,
          compareAccountAnalytics: true
        },
        beforeEnter: async (to, from, next) => {
          const currentAccount = store.getters.currentAccount
          if (!getDeepProperty(currentAccount, 'features.has_network_analytics')) {
            next({
              name: 'audience',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      {
        path: 'compare/overlap',
        name: 'compare-overlap',
        component: Overlap,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'Overlap' }
          ],
          compareAccountAnalytics: true,
          hideNetwork: true,
          allShowsDisabled: true
        },
        beforeEnter: async (to, from, next) => {
          const currentAccount = store.getters.currentAccount
          const featureFlags = store.getters.featureFlags
          if (!getDeepProperty(currentAccount, 'features.has_network_analytics') ||
            !getDeepProperty(featureFlags, 'overlapReport_2023')) {
            next({
              name: 'audience',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      {
        path: 'compare/dma',
        name: 'compare-dma',
        component: DMA,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'DMA' }
          ],
          compareAccountAnalytics: true
        }
      },
      {
        path: 'compare/location/:region?',
        name: 'compare-location',
        component: ShowLocation,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'Location' }
          ],
          showPodcastMenu: true,
          compareAccountAnalytics: true
        },
        beforeEnter: async (to, from, next) => {
          const currentAccount = store.getters.currentAccount
          if (!getDeepProperty(currentAccount, 'features.has_network_analytics')) {
            next({
              name: 'audience',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      {
        path: 'compare/webplayers',
        name: 'compare-webplayers',
        component: WebPlayers,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'Web Players' }
          ],
          showPodcastMenu: true,
          compareAccountAnalytics: true
        },
        beforeEnter: async (to, from, next) => {
          const currentAccount = store.getters.currentAccount
          if (!getDeepProperty(currentAccount, 'features.has_network_analytics')) {
            next({
              name: 'audience',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      {
        path: 'compare/technology',
        name: 'compare-technology',
        component: Technology,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Compare Shows' },
            { title: 'Technology' }
          ],
          showPodcastMenu: true,
          compareAccountAnalytics: true
        },
        beforeEnter: async (to, from, next) => {
          const currentAccount = store.getters.currentAccount
          if (!getDeepProperty(currentAccount, 'features.has_network_analytics')) {
            next({
              name: 'audience',
              params: {
                accountId: getDeepProperty(to, 'params.accountId')
              }
            })
            return
          }
          next()
        }
      },
      {
        path: 'campaigns',
        name: 'audience-campaigns',
        component: Campaigns,
        meta: {
          breadcrumbs: [
            { title: 'Audience' },
            { title: 'Campaigns' }
          ],
          showPodcastMenu: true
        }
      },
      {
        path: '*',
        redirect: { name: 'audience' }
      }
    ]
  }
]

export default audienceRoutes
